module.exports = __webpack_public_path__ + "img/whats-new-3_en.fc211bf.jpg";